<template>
    <div class="flex flex-col text-center max-w-800 mx-auto">
        <div class="mt-50 mb-110 mx-auto lg:w-800 flex flex-wrap justify-center lg:justify-between">
            <div v-for="(step, stepIndex) in stepItems" :key="stepIndex" class="w-1/2 md:w-1/3 md:max-w-210 mb-20">
                <ResponsiveIcon v-if="step.icon"
                                :image-url="step.icon.url"
                                :width="70"
                                :height="70"
                                :alt-text="step.headline"
                                class="w-70 h-70 mb-15"/>
                <div class="font-semi-bold leading-none text-16">
                    {{ step.headline }}
                </div>
                <p class="text-12 wysiwyg wysiwyg-link-underline" v-html="step.description"/>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { StepBlockViewModel, StepsBlockViewModel } from '@/types/contentServerContract';

const props = defineProps({
    content: {
        type: Object as PropType<StepsBlockViewModel>,
        required: true
    },
    isFirstBlock: {
        type: Boolean,
        required: true
    }
});

const stepItems = computed((): StepBlockViewModel[] => {
    return (props.content?.stepItems.map(s => s.content) as StepBlockViewModel[]) || [];
});
</script>
